import { Stack } from "@/Components/v2/atoms/Stack";
import { BoldSpan, Typography } from "@/Components/v2/atoms/Typography";

import WelcomeImage from "../../images/welcome.svg";

interface WelcomeProps {
  title: string;
}

const Welcome: React.FC<WelcomeProps> = ({ title }) => {
  const insightTitle = `${title} Insights`;
  const isGeographicInsights = title === "Geographic";
  const description = isGeographicInsights
    ? "Select a geography to view insights for all channels in that region, or select a specific channel to compare ROI for that channel across all your geographies."
    : "To get started, select a business unit to compare ROIs for all corresponding campaigns. Then, drill down by selecting a specific channel or campaign.";
  const note = isGeographicInsights
    ? "Only geographic areas with sufficient regional data are available."
    : "Only campaigns with sufficient ROI data are available.";
  const analysisType = isGeographicInsights ? "geography" : "campaign";

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      padding={4}
      paddingX={10}
      margin={4}
      borderRadius={4}
    >
      <img src={WelcomeImage} alt={`Welcome to ${insightTitle} image`} width="80%" />
      <Typography variant="h5" fontWeight={600}>
        Welcome to {insightTitle}
      </Typography>
      <Typography variant="body1">
        {insightTitle} allows you to analyze your channel ROI by {analysisType}.
      </Typography>
      <Typography variant="body1">{description}</Typography>
      <Typography variant="body1">
        <BoldSpan>Note:</BoldSpan> {note}
      </Typography>
    </Stack>
  );
};

export default Welcome;
